// extracted by mini-css-extract-plugin
export default {"container":"ModalAddProductToCategory_container__5bae0","wrapperInput":"ModalAddProductToCategory_wrapperInput__hiwJQ","box":"ModalAddProductToCategory_box__1zgD3"};